import * as React from 'react'

import { Plan } from '../../../../commons/Plan'
import dayjs from '../../../../commons/plugins/dayjs'
import * as styles from './PlanCard.css'

interface PlanCardProps {
  plan: Plan
  isSelected: boolean
}

const getDateLimitInfo = () => {
  const todayRaw = dayjs()
  const today = todayRaw.format('YYYY/MM/DD')
  const expireDateText = '2ヶ月間有効'
  const expireDate = todayRaw
    .add(2, 'month')
    .endOf('day')
    .subtract(1, 'day')
    .format('YYYY/MM/DD')
  return { today, expireDate, expireDateText }
}

const PlanCard: React.FunctionComponent<PlanCardProps> = ({ plan, isSelected }) => {
  const planInfo = Plan.info(plan)
  const { today, expireDate, expireDateText } = getDateLimitInfo()
  return (
    <div className={isSelected ? styles.selectedContainer : styles.container}>
      <div className={styles.textPart}>
        <p className={styles.title}>{planInfo.name}</p>
        <p className={styles.limit}>
          クイズに参加できる人数 <span className={styles.bold}>{planInfo.limit}</span>
        </p>
        <p className={styles.projectLimit}>
          <span className={styles.bold}>1プロジェクト</span>のみ
        </p>
        <p className={styles.dateLimit}>
          <span className={styles.bold}>{expireDateText}</span>（{today}~{expireDate})
        </p>
      </div>
      <div className={styles.pricePart}>
        <p className={styles.price}>
          {planInfo.price}
          <span className={styles.yen}>円</span>
        </p>
        <p className={styles.priceWithTax}>税込 {planInfo.priceWithTax}円</p>
      </div>
    </div>
  )
}

export default PlanCard
